import { render, staticRenderFns } from "./BaseUpdatePrompt.vue?vue&type=template&id=7517ed43&scoped=true&"
import script from "./BaseUpdatePrompt.vue?vue&type=script&lang=js&"
export * from "./BaseUpdatePrompt.vue?vue&type=script&lang=js&"
import style0 from "./BaseUpdatePrompt.vue?vue&type=style&index=0&id=7517ed43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7517ed43",
  null
  
)

export default component.exports